var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayGif)?_c('div',{staticClass:"px-2 fake-link position-relative"},[_c('giphy-viewer',{attrs:{"gif":_vm.creatorPost.gif.meta}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }